import Head from 'next/head';


import Dashboard from '../src/legacy/components/pages/Dashboard/Dashboard';
import Sidebar from 'legacy/components/pageLayout/Sidebar/Sidebar';
import useFCM from 'legacy/common/hooks/useFCM';

export const DashboardPage = ({ router }): JSX.Element => {
  useFCM();
  return (
    <>
      <Head>
        <title>Dashboard | Bounce</title>
      </Head>


      <div className="container mx-auto">
        <div className="flex">
          <div className="hidden md:block ">
            <Sidebar />
          </div>
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore */}
          <Dashboard router={router} />
        </div>
      </div>
    </>
  );
};

export default DashboardPage;
